// vendors
import "bootstrap";
import "jquery-validation";

// template
import {
  setValidationDefaults,
  initializeValidation,
} from "./js/config/userValidation.js";

/**
 * Inicializa os módulos e configurações de validação para a página.
 *
 * Importa as bibliotecas externas necessárias e configura a validação do formulário
 * ao carregar o documento.
 */
$(function () {
  // Define as configurações padrão de validação
  setValidationDefaults();

  // Inicializa a validação do formulário
  initializeValidation();

  // Toggle password visibility
  $(document).on("click", "#togglePassword", function () {
    const passwordField = $("#password");
    const icon = $(this).find("i");
    const type =
      passwordField.attr("type") === "password" ? "text" : "password";

    // Toggle the password field type
    passwordField.attr("type", type);

    // Toggle the icon classes
    icon.toggleClass("fa-eye fa-eye-slash");
    $(this)
      .attr("aria-pressed", type === "text" ? "true" : "false")
      .attr("aria-label", type === "text" ? "Ocultar senha" : "Mostrar senha");
  });
});
